import { Engine } from '../../core/Engine';
import { SelectElementCommand } from '../Commands';

export class SelectElementCommandHandler {
    engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: SelectElementCommand) {
        const obj = this.engine.find(command.uuid);
        if (obj) {
            this.engine.selectedElement = obj;
        }
    }
}
